// Migration: v4 → v5
// Canvas items gained group layout fields: parentId, level, childIds, layoutDirection.

import type { MigratableTemplateContent } from './types';

export const migrateV4ToV5 = (data: MigratableTemplateContent): void => {
  const canvas = data.canvas;
  if (canvas && typeof canvas === 'object' && !Array.isArray(canvas)) {
    for (const item of Object.values(canvas)) {
      if (item.parentId === undefined) {
        item.parentId = null;
      }
      if (item.level === undefined) {
        item.level = 0;
      }
      if (item.childIds === undefined) {
        item.childIds = [];
      }
      if (item.layoutDirection === undefined) {
        item.layoutDirection = 'vertical';
      }
    }
  }
  data.version = '5';
};
